// extracted by mini-css-extract-plugin
export var paragraph = "paragraph-module--paragraph--V3COx";